import { useState } from 'react'
import { Link } from 'react-router-dom'
import { sendPasswordResetEmail } from 'firebase/auth'
import { getFirebaseAuth } from '../../lib/firebase'
import AuthLayout from './AuthLayout'

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('')
  const [sent, setSent] = useState(false)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')
  async function submit(e: React.FormEvent) {
    e.preventDefault()
    if (busy) return
    setError(''); setBusy(true)
    try {
      const auth = getFirebaseAuth()
      if (!auth) throw new Error('unavailable')
      await sendPasswordResetEmail(auth, email.trim())
      setSent(true)
    } catch (err) {
      const code = (err as { code?: string }).code
      if (code === 'auth/user-not-found') setSent(true)
      else setError(code === 'auth/too-many-requests' ? 'Please wait before requesting another link.' : 'We couldn’t send the link. Check your connection and try again.')
    } finally { setBusy(false) }
  }
  return <AuthLayout>
    <p className="auth-eyebrow">LET’S GET YOU BACK IN</p>
    <h1 className="auth-title">{sent ? 'Check your inbox.' : 'Forgot password?'}</h1>
    <p className="auth-subtitle">{sent ? 'If an account uses this email, you’ll receive a password reset link. Check your spam folder too.' : 'Enter your account email and we’ll send you a link to reset your password.'}</p>
    {!sent && <form className="auth-form" onSubmit={submit}>
      {error && <p className="auth-error" role="alert">{error}</p>}
      <label className="auth-label">Email address<input className="auth-input" type="email" required autoComplete="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@yourbusiness.com" /></label>
      <button className="auth-btn auth-btn--primary" disabled={busy}>{busy ? 'Sending…' : 'Send reset link'} <span aria-hidden="true">→</span></button>
    </form>}
    {sent && <p className="auth-hint" role="status">Follow the instructions in the email, then return here to sign in.</p>}
    <p className="auth-footer"><Link to="/login">← Back to sign in</Link></p>
  </AuthLayout>
}
